// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"90":"cdd490e3","137":"8b2f203e","175":"db772085","238":"7eabffdd","310":"194e6fc8","377":"e1d60ee8","489":"7cbad66f","761":"666d9714","975":"40b801d9"}[chunkId] + ".chunk.css";
};